module.exports = __webpack_public_path__ + "img/bg-camera-tablet-pr-vector.d638f01a.png";